module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/additional-briefing-cancel.56ed5f65.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/additional-briefing-cancel.png
// module id = 3725
// module chunks = 11